import { initialStateFactory, reducerFactory, sagasFactory } from 'utils/factories';
import actionsFactory from 'utils/factories/actions';
import { DEVICE_VERIFICATION } from './actionTypes';

// actions
const actions = actionsFactory(DEVICE_VERIFICATION);
export { actions };

// reducer
const initialState = initialStateFactory();
const reducer = reducerFactory(DEVICE_VERIFICATION);
export default (state = initialState, action) => reducer(state, action);

// sagas
const sagas = sagasFactory(DEVICE_VERIFICATION, '/device_verifications');
export { sagas };
